import { StyledCashmanCasino } from './style';
import { BundleProps } from '../types';
import { Box } from '@mui/system';
import {
    calculateSaleStrokedNumber,
    formattingNumber
} from '../../Helper/utils/utils';
import CashmanCasinoBundlePrice from './BundlePrice';
import { generateSalePercentageBasedOnType } from '../../../utils';
import { EGradientDirection, EProductPriority } from '../../Helper/enums';
import { CashmanTooltip } from './Tooltip/CashmanTooltip';

const bgSaleBadge =
    'https://media.appcharge.com/media/shop-images/cashman-assets/sale-badge.png';
const rarityStar =
    'https://media.appcharge.com/media/shop-images/cashman-assets/rarity-star.png';
const tooltipIcon =
    'https://media.appcharge.com/media/shop-images/cashman-assets/tooltip-icon-no-border.png';

function Bundle({
    price,
    productList,
    backgroundSrc,
    backgroundColor = {
        colorOne: '#406cf9',
        colorTwo: '#6449ff',
        gradientDirection: EGradientDirection.BottomToTop
    },
    productsQuantityFormat,
    salePercentage = 0,
    salePercentageDisplayType,
    amountBeforeSale
}: BundleProps) {

    const starsArray = Array.from({
        length: productList[1]?.rarityProductInfo?.stars
    });
    const mainProduct = productList.find((product) => product.priority === EProductPriority.MAIN);
    const subProduct = productList.find((product) => product.priority === EProductPriority.SUB);

    return (
        <StyledCashmanCasino
            productColor={
                productList.length > 0 ? productList[0].textFontColorHex : ''
            }
            backgroundSrc={backgroundSrc}
            backgroundColor={backgroundColor}
            className="cashman-bundle"
        >
            {salePercentage > 0 && (
                <div className="cashman-bundle__sale-badge">
                    <img
                        src={bgSaleBadge}
                        alt={'bg sale image'}
                        style={{ width: '65%' }}
                    />
                    <p className="cashman-bundle__sale-badge__text">
                        {generateSalePercentageBasedOnType(
                            salePercentage,
                            salePercentageDisplayType
                        ) + ` MORE`}
                    </p>
                </div>
            )}
            <Box className={'cashman-bundle__products-container'}>
                <div className="cashman-bundle__product main-product">
                    {mainProduct && (
                        <>
                            <div className={'product-img'}>
                                <img
                                    src={mainProduct?.images.product}
                                    alt="product"
                                />
                            </div>
                            <div className="text-container">
                                <Box className="text-container__quantity">
                                    {mainProduct.images.productPrefix && (
                                        <img
                                            src={
                                                mainProduct.images
                                                    .productPrefix
                                            }
                                            alt="coin"
                                        />
                                    )}
                                    {productList[0].quantityDisplay}
                                </Box>
                                {salePercentage > 0 && (
                                    <Box className="text-container__stroked">
                                        {amountBeforeSale ??
                                            formattingNumber(
                                                calculateSaleStrokedNumber(
                                                    mainProduct.quantity,
                                                    salePercentage,
                                                    salePercentageDisplayType
                                                ),
                                                productsQuantityFormat
                                            )}
                                    </Box>
                                )}
                            </div>
                        </>
                    )}
                </div>
                <div className="cashman-bundle__product secondary-product">
                    {subProduct && (
                        <>
                            <div className={'secondary-product__container'}>
                                <div className={'product-img'}>
                                    <img
                                        src={subProduct?.images.product}
                                        alt="product"
                                    />
                                </div>

                                <div className="text-container">
                                    <div className="product-quantity">
                                        {subProduct.quantityDisplay}
                                    </div>
                                    <div className="product-rarity">
                                        {
                                            subProduct.rarityProductInfo
                                                ?.rarityText
                                        }
                                        <div className="product-rarity-stars">
                                            {starsArray.map((_, index) => (
                                                <img
                                                    key={index}
                                                    src={rarityStar}
                                                    alt="rarity star"
                                                />
                                            ))}{' '}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {subProduct.rarityProductInfo?.tooltipText && (
                                <CashmanTooltip
                                    content={
                                        subProduct.rarityProductInfo
                                            ?.tooltipText
                                    }
                                >
                                    <img
                                        className={'tooltip-icon'}
                                        src={tooltipIcon}
                                        alt={'tooltip-icon'}
                                    ></img>
                                </CashmanTooltip>
                            )}
                        </>
                    )}
                </div>
            </Box>
            <CashmanCasinoBundlePrice price={price}></CashmanCasinoBundlePrice>
        </StyledCashmanCasino>
    );
}

export default Bundle;
